/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Sync_Status_Syncing_And_Generating_CommitInputs */



/**
* | output |
* | --- |
* | "Performing sync and generating new commit... please wait." |
*
* @param {Team_Sync_Status_Syncing_And_Generating_CommitInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_sync_status_syncing_and_generating_commit = /** @type {((inputs?: Team_Sync_Status_Syncing_And_Generating_CommitInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Sync_Status_Syncing_And_Generating_CommitInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Synchronisation et génération d’un nouveau commit... veuillez patienter.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Synchronisierung wird durchgeführt und ein neuer Commit generiert... bitte warten.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esecuzione della sincronizzazione e generazione di un nuovo commit... attendere.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выполняется синхронизация и генерация нового коммита... пожалуйста, подождите.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Realizando sincronización y generando nueva confirmación... por favor espere.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在执行同步并生成新的提交……请稍候。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("同期を実行して新しいコミットを生成しています...お待ちください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सिंक्रोनाइज़ेशन किया जा रहा है और नया कमिट जनरेट किया जा रहा है... कृपया प्रतीक्षा करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sincronizando e gerando novo commit... aguarde.")
	return /** @type {LocalizedString} */ ("Performing sync and generating new commit... please wait.")
});